import { render, staticRenderFns } from "./BackdropOverlay.vue?vue&type=template&id=461bcf54&"
import script from "./BackdropOverlay.vue?vue&type=script&lang=ts&"
export * from "./BackdropOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBackdropOverlay: require('/home/vsts/work/1/a/NuxtApp/components/base/BackdropOverlay.vue').default})
